export default __webpack_public_path__ + "static/layout-dont-dark-5532424fb8a44ef3739f0f6e13db7a72.png";